import { render, staticRenderFns } from "./FormularioListas.vue?vue&type=template&id=e9d84fe4"
import script from "./FormularioListas.vue?vue&type=script&lang=js"
export * from "./FormularioListas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports